import Vue from 'vue'
import Router from 'vue-router'
import store from './store/index'

Vue.use(Router)

const router = new Router({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Identity',
      component: () => import('@/views/users/Identity.vue'),
      meta: {
        title: 'Identity'
      }
    },
    {
      path: '/CandidateInfo',
      name: 'CandidateInfo',
      component: () => import('@/views/users/CandidateInfo.vue'),
      meta: {
        title: 'CandidateInfo'
      }
    },
    {
      path: '/CandidateReport',
      name: 'CandidateReport',
      component: () => import('@/views/users/CandidateReport.vue'),
      meta: {
        title: 'CandidateReport'
      }
    },
    {
      path: '/CandidateShow',
      name: 'CandidateShow',
      component: () => import('@/views/users/CandidateShow.vue'),
      meta: {
        title: 'CandidateShow'
      }
    },
    {
      path: '/SkillsCentre',
      name: 'SkillsCentre',
      component: () => import('@/views/users/SkillsCentre.vue'),
      meta: {
        title: 'SkillsCentre'
      }
    },
    {
      path: '/Login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "users" */ '@/views/users/Login.vue'),
      meta: {
        title: 'Login'
      }
    },
    {
      path: '/CoachList',
      name: 'CoachList',
      component: () => import(/* webpackChunkName: "users" */ '@/views/coach/list.vue'),
      meta: {
        title: 'CoachList'
      }
    },
    {
      path: '/CoachInfo',
      name: 'CoachInfo',
      component: () => import('@/views/coach/CoachInfo.vue'),
      meta: {
        title: 'CoachInfo'
      }
    },
    {
      path: '/CoachShow',
      name: 'CoachShow',
      component: () => import('@/views/coach/CoachShow.vue'),
      meta: {
        title: 'CoachShow'
      }
    },
    {
      path: '/Engagement',
      name: 'Engagement',
      component: () => import('@/views/coach/Engagement.vue'),
      meta: {
        title: 'Engagement'
      }
    },
    {
      path: '/Jobs',
      name: 'Jobs',
      component: () => import(/* webpackChunkName: "users" */ '@/views/Jobs/index.vue'),
      meta: {
        title: 'Jobs'
      }
    },
    {
      path: '/TermsOfService',
      name: 'TermsOfService',
      component: () => import(/* webpackChunkName: "users" */ '@/views/users/components/TermsOfService.vue'),
      meta: {
        title: 'TermsOfService'
      }
    },
    {
      path: '/TalentPrivacyPolicy',
      name: 'TalentPrivacyPolicy',
      component: () => import(/* webpackChunkName: "users" */ '@/views/users/components/TalentPrivacyPolicy.vue'),
      meta: {
        title: 'TalentPrivacyPolicy'
      }
    },
    {
      path: '/ProfessionalsPrivacyPolicy',
      name: 'ProfessionalsPrivacyPolicy',
      component: () => import(/* webpackChunkName: "users" */ '@/views/users/components/ProfessionalsPrivacyPolicy.vue'),
      meta: {
        title: 'ProfessionalsPrivacyPolicy'
      }
    },
    {
      path: '*',
      name: 'NotFind',
      component: () => import(/* webpackChunkName: "home" */ '@/views/404.vue'),
      meta: {
        title: '404'
      }
    }
  ]
})

// 页面刷新时，重新赋值token
if (localStorage.getItem('token')) {
  store.commit('BIND_LOGIN', localStorage.getItem('token'))
}

export default router
